export const HERO_BANNER_STYLES = {
  root: "relative w-full overflow-hidden",
  imageWrapper:
    "relative h-[680px] sm:h-[720px] md:h-[460px] lg:h-[520px] w-full",
  image: "absolute inset-0 h-full w-full object-cover",
  overlay:
    "absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-black/60",
  content:
    "absolute inset-0 flex flex-col items-center justify-center px-4 text-center text-white",
  logo: "mb-3 h-[42px] w-auto",
  title:
    "text-[48px] sm:text-[72px] md:text-[96px] lg:text-[120px] font-bold leading-none tracking-tight drop-shadow-md",
  subtitle:
    "mt-4 max-w-2xl text-[20px] sm:text-[26px] md:text-[32px] font-extralight leading-[1.2] tracking-normal text-center",
  navButton:
    "absolute top-1/2 -translate-y-1/2 z-10 hidden md:flex items-center justify-center w-11 h-11 rounded-full bg-white shadow-lg hover:shadow-xl transition-shadow duration-200",
  prevButton: "left-16",
  nextButton: "right-16",
  navIcon: "w-3.5 h-3.5 text-ticketon-dark-blue",
} as const;
